// DS: i9.14
import React, { useId } from 'react';
import IconWrap from '../../IconWrap';
const TradingFlame = (props)=>{
    const gradient1Id = useId();
    const gradient2Id = useId();
    const gradient3Id = useId();
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: `url(#${gradient1Id})`,
        fillRule: "evenodd",
        d: "M8 .5h-.56v1.11h-.57v.56h-.56v.55h-.56V4.4h-.56v1.1h-.57v2.78h-.56v.55H3.5v5h.56v.56h.57v.55h.56v.56h5.62v-.56h1.13v-1.66h.56V9.94h-.56V8.28h-.56V7.17h-.57V6.6h-.56v-.55h-.56V5.5h-.56v-.56h-.57V4.4H8V3.28h-.56V2.17H8zM5.19 12.17h-.57V9.94h.57V9.4h.56v-.56h.56V6.61h.57v-.55H6.3V4.39h.57v.55h.56v.56H8v.56h.56v.55H9.7v.56h.56v1.1h.56V9.4h.56v3.33h-.56v1.67H5.75v-.56h-.56v-1.66Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: `url(#${gradient2Id})`,
        fillRule: "evenodd",
        d: "M6.88 4.4H6.3v1.66h.57v.55H6.3v2.23h-.56v.55h-.56v.56h-.57v2.22h.57v1.67h.56v.55h5.06v-1.67h.56V9.4h-.56V8.28h-.56V7.17h-.56V6.6H8.56v-.55H8V5.5h-.56v-.55h-.57v-.56Zm-.57 7.77h-.56v-1.11h.56V9.95h.57v-.56h.56V6.61H8v.56h.56v1.11h.56v.56h.57v1.1h.56v1.12h.56v1.1H9.7v1.12h-.56v.56H6.87v-.56h-.56z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: `url(#${gradient3Id})`,
        d: "M7.44 6.6H8v.56h.56v1.12h.56v.55h.57v1.11h.56v1.11h.56v1.11H9.7v1.12h-.57v.55H6.87v-.55h-.56v-1.12h-.56v-1.1h.56V9.93h.56V9.4h.57z"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: gradient1Id,
        x1: "8",
        x2: "8",
        y1: "0.5",
        y2: "15.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#973AFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.52",
        stopColor: "#A639D8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.7",
        stopColor: "#B239BB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#B538B2"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: gradient2Id,
        x1: "8",
        x2: "8",
        y1: "4.39",
        y2: "14.39",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#EE77FE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.81",
        stopColor: "#F483AA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#F58792"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: gradient3Id,
        x1: "8.28",
        x2: "8.28",
        y1: "6.61",
        y2: "13.83",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFABD1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.62",
        stopColor: "#FFAEC2"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.84",
        stopColor: "#FFB4A0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#FFB987"
    })))));
};
TradingFlame.displayName = 'TradingFlame';
export default TradingFlame;

//# sourceMappingURL=TradingFlame.js.map